var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "line_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 .566h24v22.868H0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.237 8.785a.233.233 0 0 1-.233.234h-2.287v.884h2.287c.129 0 .233.104.233.234v.84a.233.233 0 0 1-.233.235h-2.287v.884h2.287c.129 0 .233.105.233.233v.842a.233.233 0 0 1-.233.234h-3.363a.23.23 0 0 1-.161-.065l-.004-.003-.003-.004a.23.23 0 0 1-.066-.161V7.943c0-.062.025-.12.065-.161l.004-.004.003-.003a.24.24 0 0 1 .162-.066h3.363c.129 0 .233.105.233.235zm-4.648 4.387a.233.233 0 0 1-.233.233h-.842a.2.2 0 0 1-.06-.008l-.004-.001-.015-.005-.008-.002-.011-.005-.011-.006-.006-.004-.015-.008-.002-.002a.2.2 0 0 1-.06-.058l-2.398-3.24v3.106a.234.234 0 0 1-.235.233h-.841a.233.233 0 0 1-.234-.233v-5.23c0-.128.105-.233.234-.233h.849q.007 0 .013.002h.012q.005.002.01.003l.013.003q.005 0 .009.002.007.001.013.004l.008.003q.007.001.013.006.004 0 .008.003l.012.007q.004.001.007.004l.012.009q.003.001.006.005l.013.01.004.004.014.014.002.002.018.023 2.396 3.236V7.943c0-.13.104-.234.234-.234h.842c.129 0 .233.105.233.234zm-5.793 0a.233.233 0 0 1-.234.233H8.72a.233.233 0 0 1-.233-.233v-5.23c0-.128.104-.233.233-.233h.842c.129 0 .234.105.234.234zm-2.03-.001a.233.233 0 0 1-.233.234H4.17a.23.23 0 0 1-.168-.072.23.23 0 0 1-.065-.161V7.943c0-.13.104-.234.234-.234h.841c.129 0 .234.105.234.234v4.153h2.287c.129 0 .233.105.233.233zM24 10.305c0-5.37-5.383-9.74-12-9.74-6.616 0-12 4.37-12 9.74 0 4.813 4.269 8.845 10.036 9.607.39.084.923.258 1.057.592.121.303.079.779.039 1.085l-.171 1.027c-.053.303-.242 1.187 1.039.647s6.911-4.07 9.428-6.967C23.167 14.389 24 12.453 24 10.305",
    clipRule: "evenodd"
  }))));
};
export default SvgLine;